export default __webpack_public_path__ + "static/media/004-ordenador-porttil.6992a298.png";